import React, { useContext } from 'react';
import BaseGridToolbar from '../../../components/shared/toolbar/BaseGridToolbar';
import EditModeToggle from '../../../components/shared/table/components/EditModeToggle';
import { EditModeContext } from '../../../components/shared/table/context/EditModeContext';

const SystemAuctionLotsToolbar = ({ 
  title = 'System Auction Lots Manager',
  columns,
  data,
  selectedItems = new Set(),
  onAdd,
  onDelete,
  onRefresh,
  showQuickFilter = true,
  quickFilterProps = {}
}) => {
  const editModeContext = useContext(EditModeContext);
  const hasSelection = selectedItems.size > 0;

  // Custom action buttons
  const actionButtons = (
    <div className="flex items-center space-x-2">
      {editModeContext && <EditModeToggle />}
      
      {onRefresh && (
        <button
          onClick={onRefresh}
          className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          title="Refresh data"
        >
          <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
      )}
      
      {hasSelection && onDelete && (
        <button
          onClick={() => onDelete(selectedItems)}
          className="inline-flex items-center px-3 py-1.5 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Delete Selected ({selectedItems.size})
        </button>
      )}
      
      {onAdd && (
        <button
          onClick={onAdd}
          className="inline-flex items-center px-3 py-1.5 border border-transparent rounded-md text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add Record
        </button>
      )}
    </div>
  );

  return (
    <BaseGridToolbar
      title={title}
      columns={columns}
      data={data}
      showQuickFilter={showQuickFilter}
      quickFilterProps={quickFilterProps}
      actionButton={actionButtons}
    />
  );
};

export default SystemAuctionLotsToolbar;
